import { tv } from 'tailwind-variants';
import {
  CarouselPrevious,
  CarouselNext,
  useCarousel,
} from '@/shared/components/ui/carousel';
import { cn } from '@/shared/utils';
import ArrowLeftIcon from '@/shared/assets/arrow-left-icon.svg?react';

type Props = {
  type: 'previous' | 'next';
  className?: string;
};

const carouselButtonVariants = tv({
  slots: {
    button: 'hidden size-22 lg:flex items-center justify-center',
    icon: 'size-9',
  },
  variants: {
    type: {
      previous: {
        button: 'left-[-0.5rem]',
      },
      next: {
        button: 'right-[-1.5rem]',
        icon: 'rotate-180',
      },
    },
  },
});

const AccountsCarouselControlButton = ({ type, className }: Props) => {
  const { canScrollPrev, canScrollNext } = useCarousel();
  const Component = type === 'previous' ? CarouselPrevious : CarouselNext;
  const isVisible = type === 'previous' ? canScrollPrev : canScrollNext;
  const { button, icon } = carouselButtonVariants({ type });

  if (!isVisible) {
    return null;
  }

  return (
    <Component
      variant="carousel"
      icon={<ArrowLeftIcon className={icon()} />}
      className={cn(button(), className)}
    />
  );
};

export default AccountsCarouselControlButton;
